export default "__VITE_ASSET__Ctg9Lx9J__"